import { Col } from "antd";
import Styled from "styled-components";

const CardWrapper = Styled.div`
	border: 1px solid #f0f0f0;
	box-shadow: 0px 4px 6px -4px rgba(24, 39, 75, 0.12),
		0px 8px 8px -4px rgba(24, 39, 75, 0.08);
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-bottom: 20px;
	height: 88px;
	width: 45%;
	h3 {
		font-size: 14px;
		font-weight: 500;
	}

	@media (max-width: 767px) {
		width: 90%;
		margin-bottom: 20px;
	}

	&:hover {
		border: 1px solid #9ac2ff;
	}

	.topInfo-Wrapper {
		display: flex;
		font-size: 14px;
		font-weight: 500;
		height: 56px;
		justify-content: space-between;
		overflow: hidden;
		line-height: 22px;
		padding: 0.5rem;
		padding-top: 10px;
		text-align: left;
	}
`;

const StyledLine = Styled(Col)`
	height: 88px;
	padding: 0 !important;
	border: 1px solid #f0f0f0;
	border-radius: 2px;
	box-shadow: 0px 4px 6px -4px rgba(24, 39, 75, 0.12),
		0px 8px 8px -4px rgba(24, 39, 75, 0.08);
	cursor: pointer;

	&:hover {
		border: 1px solid #9ac2ff;
	}
`;

const FooterWrap = Styled.div`
	display: flex;
	align-items: center;
	height: 30px;
	background: #f6faff;
	border-radius: 0px 0px 2px 2px;
	padding: 0 16px;
`;

export { CardWrapper, StyledLine, FooterWrap };
